import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const supportComment = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    body: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Body - Markdown content'),

    isSystem: z
      .boolean()
      .nullable()
      .optional()
      .describe(
        "Is System - Marks an entry the site wrote, not a person\n\nA close or reopen records itself here so the thread carries the case's\nhistory. The entry is still attributed to whoever acted, so the card\nrenders it as a one-line event rather than an editable comment.",
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('createdAt'),

    createdBy: references('User'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .presentAs('reference')
      .describe('Foreign key to User'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('updatedAt'),

    updatedBy: references('User'),

    updatedById: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .presentAs('reference')
      .describe('Foreign key to User'),

    caseId: z.number().hidden().describe('Foreign key to SupportCase'),

    accountId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Account'),

    case: belongsTo('SupportCase'),

    account: references('Account'),

    attachments: hasMany('SupportAttachment', 'commentId'),
  })
  .describe('A comment on a support case. Body is markdown.')
  .as('SupportComment');

export { supportComment as supportCommentSchema };
